import React, { Component } from "react";
import {
  FormControlLabel,
  Checkbox,
  WithStyles,
  withStyles,
  Grid,
} from "@material-ui/core";
import { userStyles } from "../userManagement/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

interface MyPATMultiSelectProps extends WithStyles<typeof userStyles> {
  valueAutoComp: any;
  options: any;
  onChange: any;
  isMulti: any;
  optionsList?: any;
  placeholderText: string,
  selectedOption:string []
}

export class MyPATMultiSelect extends Component<MyPATMultiSelectProps> {
  constructor(props: MyPATMultiSelectProps) {
    super();
    this.hideOptionsList=this.hideOptionsList.bind(this);
  }

  state = {
    activeOption: 0,
    filteredOptions: [],
    showOptions: false,
    userInput: "",
    multiSelectValues: [],
    optionList: null,
    placeholder: '',
  };
  
  handleShowOptions(){
      this.setState({showOptions:!this.state.showOptions});
  }
  hideOptionsList(){
    this.setState({showOptions:false});
  }
  renderOptions() {
    const { classes } = this.props;
    return(
      <Grid className="options">
        {this.props.options.map((optionName:any, index:number) => {
          if (this.props.isMulti) {
            return (
              <Grid key={index} className={[this.props.selectedOption.includes(optionName) && classes.activeOptionItem, "optionItem"].join(' ')} >
                <FormControlLabel
                  className={[classes.customRadio, classes.marginZero].join(
                    " "
                  )}
                  control={
                    <Checkbox
                      checked={this.props.selectedOption.includes(optionName)}
                      classes={{
                        root: classes.multiCheckbox,
                        checked: classes.multiCheckedCheckbox,
                        colorPrimary: classes.primaryColor,
                      }}
                      color="primary"
                      onClick={()=>{this.props.onChange(optionName)}}
                      disableRipple
                    />
                  }
                  value={optionName}
                  label={optionName}
                  classes={{
                    label: [classes.fontSize_SM, classes.grey, classes.textElipse].join(" "),
                  }}
                />
              </Grid>
            );
          } 
        }
        )}
      </Grid>
    )
  }

  render() {
    const { classes } = this.props;
    const {showOptions}=this.state;
    
    return (
      <>
        <div className={classes.selectContainer} onClick={this.handleShowOptions.bind(this)}>
          {!showOptions && this.props.selectedOption.length === 0 && <div className="icon"><ExpandMoreIcon /></div> }
          <div className="chipInput">
            <div className="chipContainer">
              {this.props.selectedOption  && this.props.selectedOption.length>0 &&
                this.props.selectedOption.map((optionName: any) => {
                  return (
                    <span className={classes.customChip}>
                      <span className="chipLabel"> {optionName} </span>
                      <span
                        className="chipIcon"
                        onClick={() => this.props.onChange(optionName)}
                      >
                        {" "}
                        <CancelIcon />
                      </span>
                    </span>
                  );
                })}
            </div>
           {showOptions && <div className="multiSelectOptions" 
                          onBlur={this.hideOptionsList}>
                {this.renderOptions()}
            </div>}
          </div>
          
        </div>
       
      </>
    );
  }
}

// @ts-ignore
export default withStyles(userStyles)(MyPATMultiSelect);
